import React from 'react';
export function ValueSummary() {
  return <div className="max-w-4xl mx-auto mb-12 text-center py-8" data-id="element-411">
      <h2 className="text-3xl md:text-5xl font-bold text-red-600 mb-2" data-id="element-412">
        $2,773 VALOR DE LOS BONOS
      </h2>
      <div className="flex items-center justify-center gap-3" data-id="element-413">
        <span className="text-2xl md:text-4xl font-bold text-black" data-id="element-414">
          Solo por
        </span>
        <span className="text-4xl md:text-6xl font-black text-[#06b6d4] uppercase" data-id="element-415">
          GRATIS
        </span>
      </div>
    </div>;
}